import { css } from '@emotion/core';
import { variables, globalTokens } from '@domain-group/fe-brary';
var font = variables.font;
export var wrapper = {
  name: "4yxxwq",
  styles: "display:block;height:100%;"
};
export var container = /*#__PURE__*/css("position:absolute;width:100vw;height:100%;background-color:", globalTokens.colors.white, ";font-family:", font.bodyFontFamily, ";font-size:", font.baseMobileFontSize, ";font-weight:", font.headingFontWeight, ";");
export var priceRange = {
  name: "19fro2g",
  styles: "margin:8px 16px 23px;"
};
export var propertyType = {
  name: "1vrc4df",
  styles: "margin:0 16px;"
};
export var propertyFeatures = {
  name: "17vzlrq",
  styles: "margin:10px 0 0 16px;"
};
export var moreOptionsContent = {
  name: "19midj6",
  styles: "padding:16px;"
};
export var moreOptions = {
  name: "1r2f04i",
  styles: "margin-bottom:10px;"
};